// extracted by mini-css-extract-plugin
export var backdropBlur = "_d0-0";
export var contentCard = "_d0-5";
export var frame = "_d0-2";
export var image = "_d0-4";
export var imagePane = "_d0-3";
export var modal = "_d0-1";